/**
 * Modules listed here intentionally share one tab across all first-level
 * children. Keep this explicit: most menu leaves are independent tabs.
 */
const SHALLOW_MODULE_KEYS = new Set<string>([]);

/**
 * These paths are menu groups rather than leaf modules. Their third segment
 * identifies an independent menu leaf, while deeper routes remain detail
 * pages of that leaf.
 */
const THREE_LEVEL_MODULE_GROUPS = new Set<string>([
  '/general/hr',
  '/logistics/shipment',
  '/sales/transfer',
  '/sales/outsourcing',
]);

export const getTabModuleKey = (path: string): string => {
  const cleanPath = path.split('?')[0];
  const parts = cleanPath.split('/').filter(Boolean);

  if (parts.length <= 1) {
    return cleanPath;
  }

  const firstLevel = `/${parts[0]}`;
  if (SHALLOW_MODULE_KEYS.has(firstLevel)) {
    return firstLevel;
  }

  const secondLevel = `/${parts.slice(0, 2).join('/')}`;
  if (THREE_LEVEL_MODULE_GROUPS.has(secondLevel) && parts.length >= 3) {
    return `/${parts.slice(0, 3).join('/')}`;
  }

  return secondLevel;
};

export const isSameTabModule = (path1: string, path2: string): boolean => {
  const moduleKey1 = getTabModuleKey(path1);
  const moduleKey2 = getTabModuleKey(path2);
  return moduleKey1 === moduleKey2 && moduleKey1 !== '/';
};
